'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$FreemiumSeedResult(name, error) {
  this.Yv = null;
  this.E4 = null;
  this.Yv = name;
  this.E4 = error;
}
export { $c_Lpresto_types$FreemiumSeedResult as $c_Lpresto_types$FreemiumSeedResult };
$p = $c_Lpresto_types$FreemiumSeedResult.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$FreemiumSeedResult;
/** @constructor */
function $h_Lpresto_types$FreemiumSeedResult() {
}
export { $h_Lpresto_types$FreemiumSeedResult as $h_Lpresto_types$FreemiumSeedResult };
$h_Lpresto_types$FreemiumSeedResult.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$FreemiumSeedResult)) {
    if ((this.Yv === x$0.Yv)) {
      var x = this.E4;
      var x$2 = x$0.E4;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "FreemiumSeedResult";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Yv;
  }
  if ((n === 1)) {
    return this.E4;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$FreemiumSeedResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jT)));
}
export { $isArrayOf_Lpresto_types$FreemiumSeedResult as $isArrayOf_Lpresto_types$FreemiumSeedResult };
var $d_Lpresto_types$FreemiumSeedResult = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$FreemiumSeedResult, "presto.types$FreemiumSeedResult", ({
  jT: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$FreemiumSeedResult as $d_Lpresto_types$FreemiumSeedResult };
//# sourceMappingURL=presto.types$-Freemium-Seed-Result.js.map
